import styled from 'styled-components';
import dt from '../../../../shared/theme';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 0.75px solid #D7DFE7;
  border-radius: 6px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  padding: 12px 24px 12px 12px;

  ${props => dt(props).theme.isMobileOrTablet && `
    flex-direction: column;
    padding: 12px 12px 20px;
  `};

  ${props => dt(props).theme.isLarge && `
    height: 104px;
  `};

  ${props => dt(props).theme.isXXLarge && `
    padding-left: 16px;
    padding-right: 32px;
  `};

  &:hover {
    border: 0.75px solid #627484;
    box-shadow: 0px 7px 12px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
`;

const Primary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;

  ${props => dt(props).theme.isLarge && !dt(props).theme.isXLarge && `
    max-width: calc(100% - 520px);
    margin-right: 24px;
  `};

  ${props => dt(props).theme.isXLarge && `
    max-width: calc(100% - 640px);
    margin-right: 32px;
  `};
`;

const TypeSeparator = styled.span`
  color: #8EA3B5;
  margin: 0 6px;
  font-size: 14px;
`;

const Name = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 17px;
  line-height: 110%;
  margin-top: 4px;

  ${props => dt(props).theme.isLarge && `
    font-size: 16px;
    margin-top: 4px;
  `};

  ${props => dt(props).theme.isXXLarge && `
    font-size: 19px;
  `};
`;

const AssetClass = styled.div`
  color: ${props => dt(props).theme.secondaryColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  font-size: 13px;
  line-height: 120%;
  margin-top: 4px;
  text-transform: capitalize;

  ${props => !dt(props).theme.isXLarge && `
    margin-top: 4px;
  `};

  ${props => dt(props).theme.isXXLarge && `
    font-size: 16px;
  `};
`;

const Fact = styled.div`
  margin-right: 56px;
  min-width: 64px;

  ${props => dt(props).theme.isMobile && `
    margin-right: 16px;
  `};

  ${props => dt(props).theme.isMobileOrTablet && `
    &.last {
      margin-right: 0;
    }
  `};

  ${props => dt(props).theme.isLarge && `
    margin: 20px 0 auto 24px;

    &.first {
     margin-left: auto;
    }
  `};

  ${props => dt(props).theme.isXLarge && `
    margin-left: 32px;
  `};

  ${props => dt(props).theme.isXXLarge && `
    margin-left: 56px;
  `};
`;

const Title = styled.div`
  color: ${props => dt(props).theme.secondaryColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  font-size: 9px;
  line-height: 120%;
  text-transform: uppercase;

  ${props => dt(props).theme.isMobileOrTablet && `
    letter-spacing: -0.02em;
  `};

  ${props => dt(props).theme.isLarge && `
    text-align: right;
  `};

  ${props => dt(props).theme.isXLarge && `
    font-size: 12px;
  `};
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`;

const Value = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  font-size: 19px;
  line-height: 120%;
  text-transform: uppercase;
  margin-top: 4px;

  ${props => dt(props).theme.isLarge && `
    text-align: right;
  `};

  > .small {
    margin-left: 4px;
    font-size: 14px;
    text-transform: none;
  }

  > .date {
    margin-top: -6px;
    font-size: 12px;
    font-weight: ${props => dt(props).theme.fontWeightRegular};
    text-transform: none;
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export {
  Primary,
  Bottom,
  AssetClass,
  Container,
  Name,
  Fact,
  Title,
  Top,
  TypeSeparator,
  Value,
  FlexRow,
};
